import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

interface C1TitleProps extends HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode;
  as?: 'h1' | 'h2' | 'h3';
}

export function C1Title({ children, as: Tag = 'h1', className, ...props }: C1TitleProps) {
  return (
    <Tag className={cx('c1-title', className)} {...props}>
      {children}
    </Tag>
  );
}
